import type { IconSvgObject } from './types';

const CharacterPhoneticIcon: IconSvgObject = [
  ["path", { d: "M12 11H22V9.5C22 6.73858 19.7614 4.5 17 4.5C14.2386 4.5 12 6.73858 12 9.5V11ZM12 11V14.5C12 17.2614 14.2386 19.5 17 19.5H17.5C19.9853 19.5 22 17.4853 22 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 11V9.5C12 6.73858 9.76142 4.5 7 4.5H6.5C4.01472 4.5 2 6.51472 2 9M12 11V13.7857C12 16.9416 9.42115 19.5 6.26523 19.5C3.91802 19.5 2 17.5972 2 15.25C2 12.9028 3.90279 11 6.25 11H12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CharacterPhoneticIcon;
